import { render, staticRenderFns } from "./StandardCheckBox.vue?vue&type=template&id=646a933d&scoped=true"
import script from "./StandardCheckBox.vue?vue&type=script&lang=js"
export * from "./StandardCheckBox.vue?vue&type=script&lang=js"
import style0 from "./StandardCheckBox.vue?vue&type=style&index=0&id=646a933d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a933d",
  null
  
)

export default component.exports